import React from 'react';
import Search from './Search';
import TermsAndConditionsInfoTab from './termsAndConditionsInfo/TermsAndConditionsInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class TermsAndConditionsSetup extends React.Component {
    render() {
        let opts = {
            title: "Terms & Conditions Setup",
            description: "Create and modify the terms & Conditions that appears on the registration page",
            addPrivilege: App.hasPrivilege("AdminTermsAndConditionsSetupAdd"),
            addNewTitle: "Add Terms & Conditions",
            helpKey: Help.termsAndConditionsSetupHelpKey,
            recentType: "termsAndConditions",
            list: {
                url: API.App.url('/termsAndConditionsSetup/search'),
                rowKey: "termsAndConditionsId",
                columns: [
                    { key: 'description', name: 'Terms & Conditions Title', sortable: false },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "termsAndConditionsInfo", title: "Terms & Conditions Info", comp: TermsAndConditionsInfoTab, helpKey:Help.termsAndConditionsSetupInfoHelpKey },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.termsAndConditionsSetupAuditHelpKey } 
            ]
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}

export default TermsAndConditionsSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/termsAndConditionsSetup/TermsAndConditionsSetup.js